import type { Config } from 'tailwindcss';
import defaultTheme from 'tailwindcss/defaultTheme.js';

/** @type {import('tailwindcss').Config} */
export default {
    darkMode: 'selector',
    content: ['./index.html', './src/**/*.{js,ts,jsx,tsx}'],
    theme: {
        extend: {
            colors: {
                primary: '#88E59C',
                primaryLight: 'rgba(136,229,156,0.20)',
                font: '#0F172A',
            },
            fontFamily: {
                sans: ['Uncut-Sans-Regular', ...defaultTheme.fontFamily.sans],
            },
            screens: {
                smallScreenHeight: { raw: '(max-height: 1100px)' },
            },
            backgroundImage: {
                'striped-gray': 'repeating-linear-gradient(45deg, #f3f4f6, #f3f4f6 10px, #e5e7eb 10px, #e5e7eb 20px)',
            },
            spacing: {
                header: '60px',
            },
        },
    },
    plugins: [],
    safelist: [
        {
            pattern: /grid-cols-.+/,
        },
        'bg-black',
        'bg-green-400',
        'bg-green-600',
        'bg-yellow-400',
        'bg-yellow-600',
        'bg-orange-400',
        'bg-red-400',
        'bg-red-600',
        'bg-blue-600',
        'border-black',
        'border-green-400',
        'border-yellow-400',
        'border-orange-400',
        'border-red-400',
    ],
} satisfies Config;
